module.exports = __webpack_public_path__ + "img/GNSS.a0e930c4.png";